export class FeedbackSurvey {
    id: string;
    dateAdded: Date;
    domainId: string;
    isEnable: boolean;
    displayName: string;

    feedbackSurveyQuestions: Array<FeedbackSurveyQuestion>;
    feedbackSurveyResponses: Array<FeedbackSurveyResponse>;

}

export class FeedbackSurveyQuestion {
    id: string;
    order: number;
    questionType: number;
    rating: number;
    isEnable: boolean;

    feedbackQuestionId: string;
    FeedbackQuestion: FeedbackQuestion; 
}

export class FeedbackQuestion {
    id: string;
    question: string;
    questionType: number;
    rating: number;
}

export class FeedbackSurveyResponse {
    id?: string;
    feedbackSurveyId?: string;
    pageId?: string;
    impressionId?: string;
    feedbackQuestionResponses: Array<FeedbackQuestionResponse>;
}
export class FeedbackQuestionResponse {
    questionId: string;
    feedbackSurveyQuestionId: string;
    score: number;
    rating: number;
    freeTextResponse: string;
    yesNo: boolean;
}